import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { CheckPrintingDialogComponent } from './check-printing-dialog.component';
import { CheckPrintingDialogStateService } from './check-printing-dialog-state.service';

@Component({
    selector: 'app-check-printing-dialog-host',
    standalone: true,
    imports: [NgIf, CheckPrintingDialogComponent],
    template: '<app-check-printing-dialog *ngIf="state.open()" [open]="state.open()" [payable]="state.payable()" [checkIds]="[]" (closed)="state.answer($event)"></app-check-printing-dialog>',
})
export class CheckPrintingDialogHostComponent
{
    constructor(readonly state: CheckPrintingDialogStateService) {}
}
